export const FETCH_ADDVOUCHER_REQUEST = "FETCH_ADDVOUCHER_REQUEST";
export const FETCH_ADDVOUCHER_SUCCESS = "FETCH_ADDVOUCHER_SUCCESS";
export const FETCH_ADDVOUCHER_FAILURE = "FETCH_ADDVOUCHER_FAILURE";
export const FETCH_REMOVEVOUCHER_REQUEST = "FETCH_REMOVEVOUCHER_REQUEST";
export const FETCH_REMOVEVOUCHER_SUCCESS = "FETCH_REMOVEVOUCHER_SUCCESS";
export const FETCH_REMOVEVOUCHER_FAILURE = "FETCH_REMOVEVOUCHER_FAILURE";
export const VOUCHER_MIN_LENGTH_ERROR = "VOUCHER_MIN_LENGTH_ERROR";
